module.exports = __webpack_public_path__ + "img/master_2.98f5725f.svg";